import { Box, FormLabel, Grid, TextField, Typography } from '@mui/material';
import { useActividadesContext } from '../../UmmIACategories/Hook/useActividades';

const TemaTaller = () => {
  const { promptData, setPromptData} = useActividadesContext();

  const handleTema = (event) => {
    const tema = event.target.value;
   
    setPromptData((prevData) => ({
        ...prevData,
        tema_taller: tema 
      }));
  };

  return (
    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
      <Box>
      <Box sx={{ display: 'flex', flexDirection: 'column',  }}>
        <Typography sx={{ fontFamily: 'montserrat', fontSize: '1.25rem', fontWeight: 'bold', color:'#336B87' }}>
        Tema principal *
        </Typography>
        <FormLabel sx={{ fontFamily: 'montserrat', fontSize: '0.85rem' }}>Escribe aquí el tema principal del taller. </FormLabel>
        </Box>
        <TextField
          fullWidth
          variant="outlined"
          value={promptData.tema_taller}
          placeholder="Ejemplo: Estrategias de Aprendizaje Colaborativo"
          onChange={handleTema}
          InputProps={{
            sx: {
                borderRadius:2,
                mt:1,
                mb: 3,
                fontFamily: 'montserrat',
                fontSize: '0.75rem',
                color: '#005559',
                '&::placeholder': {
                    color: '#005559',

                },
                '&:before': {
                    borderBottomColor: '#005559',

                },
                '&:after': {
                    borderBottomColor: '#005559',
                },
            }
        }}
        />
      </Box>
    </Grid>
  );
};

export default TemaTaller;
